export default function TaskCheck({ done, onClick, testid }) {
  return (
    <button
      onClick={onClick}
      data-testid={testid}
      className="relative inline-flex items-center justify-center rounded-full transition-all"
      style={{
        width: 26, height: 26,
        border: `2px solid ${done ? "#0e0fed" : "#0A0A0A"}`,
        background: done ? "#0e0fed" : "white",
      }}
    >
      {done && (
        <svg width="15" height="15" viewBox="0 0 24 24" fill="none">
          <path className="moe-check-path" d="M5 12 L10 17 L19 7" stroke="white" strokeWidth="2.8" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      )}
    </button>
  );
}
